import {Injectable} from "@angular/core";
import {ActivatedRouteSnapshot, Resolve, RouterStateSnapshot} from "@angular/router";
import {Observable, filter, first} from "rxjs";
import {DbResponse} from "../../../../shared/interceptors/db-response";
import {HostingService} from "../hosting.service";

@Injectable()
export class HostingCertificateResolver implements Resolve<null> {

  constructor(
    private _hostingService: HostingService
  ) {}

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any>|Promise<any>|any {
    return new Promise((resolve: Function, reject: Function): void => {
      const websiteId: number = route.parent.data && route.parent.data['website'] ? route.parent.data['website'].id : route.parent.parent.data['website'].id;
      this._hostingService.getCertificates(websiteId)
        .pipe(filter((response: DbResponse): boolean => !!response),
        first())
        .subscribe((response) => {
          if (response.success) {
            resolve(response.data);
          }
          else {
            resolve(null);
          }
        });
    });
  }

}
